import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_btn, {
      variant: "text",
      color: "primary",
      "prepend-icon": "mdi-email-outline",
      onClick: $setup.openDialog
    }, {
      default: _withCtx(() => [
        _createTextVNode("Visszaigazoló e-mail")
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: $setup.dialog,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.dialog) = $event)),
      "max-width": "800",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h6" }, {
              default: _withCtx(() => [
                _createTextVNode("Visszaigazoló e-mail sablon")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_subtitle, { class: "text-wrap" }, {
              default: _withCtx(() => [
                _createTextVNode("A sablon szabadon szerkeszthető, majd kimásolva elküldhető a levelezőprogramból. A rendszer nem küld e-mailt.")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: $setup.recipient,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.recipient) = $event)),
                  label: "Címzett",
                  variant: "outlined",
                  density: "compact",
                  readonly: "",
                  "append-inner-icon": "mdi-content-copy",
                  "hide-details": "auto",
                  "onClick:appendInner": _cache[1] || (_cache[1] = ($event: any) => ($setup.copy($setup.recipient, 'Címzett kimásolva')))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  class: "mt-4",
                  modelValue: $setup.subject,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.subject) = $event)),
                  label: "Tárgy",
                  variant: "outlined",
                  density: "compact",
                  "append-inner-icon": "mdi-content-copy",
                  "hide-details": "auto",
                  "onClick:appendInner": _cache[3] || (_cache[3] = ($event: any) => ($setup.copy($setup.subject, 'Tárgy kimásolva')))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_textarea, {
                  class: "mt-4",
                  modelValue: $setup.body,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.body) = $event)),
                  label: "Levél szövege",
                  variant: "outlined",
                  rows: "20",
                  "hide-details": "auto",
                  spellcheck: "false"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  "prepend-icon": "mdi-restore",
                  onClick: $setup.resetTemplate
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Sablon visszaállítása")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.dialog = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Bezárás")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "flat",
                  "prepend-icon": "mdi-content-copy",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.copy($setup.body, 'Levél szövege kimásolva')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Szöveg másolása")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}